<div [innerHTML]="pageContent"></div>
<div class="news-center-loading" *ngIf="loading">
  <p>加载中...</p>
</div>
